export default __webpack_public_path__ + "static/media/seller-project.e48db717.png";